export default __webpack_public_path__ + "static/media/logo-light.00bc1ed3.svg";